import { Link } from 'react-router-dom';
import { DataTable } from '../ui/DataTable';
import { StatusPill } from '../ui/StatusPill';

/**
 * Package Assets table (Sep 3 Disc slide 5).
 * rows: [{ id, loan, borrower, batch, dealFacilitySpv, vaultState, servicingAccess }]
 * loanHref(row) returns the Digitize route for that loan/asset.
 */
export function PackageAssetsTable({
  rows,
  loanHref,
  loading = false,
  emptyMessage = 'No loans / assets in this package yet.',
}) {
  const columns = [
    {
      key: 'loan',
      header: 'Loan',
      render: (row) => {
        const label = row.loan || row.id;
        const href = typeof loanHref === 'function' ? loanHref(row) : null;
        if (!href) {
          return (
            <span className="font-semibold text-eorig-navy-600">{label}</span>
          );
        }
        return (
          <Link
            to={href}
            className="font-semibold text-eorig-navy-600 hover:text-eorig-cyan hover:underline"
          >
            {label}
          </Link>
        );
      },
    },
    {
      key: 'borrower',
      header: 'Borrower',
      render: (row) => row.borrower || '—',
    },
    {
      key: 'batch',
      header: 'Batch',
      render: (row) => row.batch || '—',
    },
    {
      key: 'dealFacilitySpv',
      header: 'Deal / facility / SPV',
      render: (row) => row.dealFacilitySpv || '—',
    },
    {
      key: 'vaultState',
      header: 'Vault state',
      render: (row) =>
        row.vaultState ? <StatusPill value={row.vaultState} /> : '—',
    },
    {
      key: 'servicingAccess',
      header: 'Servicing access',
      render: (row) => row.servicingAccess || '—',
    },
  ];

  return (
    <DataTable
      columns={columns}
      rows={rows}
      rowKey={(row) => row.id}
      loading={loading}
      emptyMessage={emptyMessage}
      minWidth={860}
    />
  );
}

/**
 * Map provider batch item + package detail into slide-5 row shape.
 */
export function mapProviderItemToAssetRow(item, detail) {
  return {
    id: item.id,
    loan: item.loan_number || item.asset_number,
    borrower: item.borrower,
    batch: detail?.reference_number || detail?.batch_id,
    dealFacilitySpv: detail?.program,
    vaultState: item.custody_state,
    servicingAccess: item.current_holder,
  };
}

/**
 * Map originator portfolio loan into slide-5 row shape.
 */
export function mapOriginatorLoanToAssetRow(loan) {
  return {
    id: loan.id,
    loan: loan.loan_id,
    borrower: loan.borrower,
    batch: loan.batch,
    dealFacilitySpv: loan.deal_facility_spv,
    vaultState: loan.vault_state,
    servicingAccess: loan.servicing_access,
  };
}
